/*
 * Infor Rich Text Editor
 */
(function($) {
  $.fn.inforRichTextEditor = function(options) {
    // Settings and Options
    var pluginName = "inforRichTextEditor",
      defaults = {
        buttons: [
          {
            icon: "h2",
            execCommand: "formatblock",
            args: "h2",
            text: "H2",
            isToggle: false
          },
          {
            icon: "h3",
            execCommand: "formatblock",
            args: "h3",
            text: "H3",
            isToggle: false
          },
          {
            icon: "normal",
            execCommand: "formatblock",
            args: "p",
            text: "normal",
            isToggle: false
          },
          { icon: "spacer" },
          //{icon: 'formatblock', execCommand: 'fontname', title: 'Format'},
          { icon: "forecolor", execCommand: "forecolor", title: "Font Color" },
          { icon: "spacer" },
          {
            icon: "bold",
            execCommand: "bold",
            title: "Make Text Bold",
            isToggle: true
          },
          {
            icon: "italic",
            execCommand: "italic",
            title: "Make Text Italicized",
            isToggle: true
          },
          {
            icon: "underline",
            execCommand: "underline",
            title: "Make Text Underlined",
            isToggle: true
          },
          { icon: "spacer" },
          {
            icon: "justifyLeft",
            execCommand: "justifyLeft",
            title: "Align Content Left"
          },
          {
            icon: "justifyCenter",
            execCommand: "justifyCenter",
            title: "Align Content Center"
          },
          {
            icon: "justifyRight",
            execCommand: "justifyRight",
            title: "Align Content Right"
          },
          { icon: "spacer" },
          //{icon: 'blockQuote', execCommand: 'formatblock', title: 'Block Quote', args: 'blockquote', text: '“'},
          {
            icon: "numberList",
            execCommand: "insertorderedlist",
            title: "Create a Numbered List"
          },
          {
            icon: "bulletList",
            execCommand: "insertunorderedlist",
            title: "Create a Bulleted List"
          },
          { icon: "spacer" },
          {
            icon: "links",
            execCommand: "createLink",
            title: "Create a Link",
            click: function(e, self) {
              self.insertLink($(e.currentTarget));
            }
          },
          { icon: "spacer" },
          {
            icon: "showHtml",
            execCommand: "showHtml",
            title: "Show Html",
            isToggle: true
          }
        ]
      },
      settings = $.extend({}, defaults, options);
    // Plugin Constructor
    function Plugin(element) {
      this.element = $(element);
      this.init();
    }
    // Actual Plugin Code
    Plugin.prototype = {
      init: function() {
        var self = this,
          editor = $(this.element);
        //Make it Content Editable
        editor.addClass("inforRichTextEditor").attr("contenteditable", true);
        //Add the Toolbar Buttons
        self.addButtons();
        //Handle Readonly
        if (editor.attr("readonly")) {
          //Was initialized in hidden state
          editor.prev(".inforToolbar").hide();
          editor.attr("contenteditable", "false");
        }
        //Setup keys
        self.handleKeys();
      },
      _saveSelection: function() {
        var sel;
        if (window.getSelection) {
          sel = window.getSelection();
          if (sel.getRangeAt && sel.rangeCount) {
            var ranges = [];
            for (var i = 0, len = sel.rangeCount; i < len; ++i) {
              ranges.push(sel.getRangeAt(i));
            }
            return ranges;
          }
        } else if (document.selection && document.selection.createRange) {
          return document.selection.createRange();
        }
        return null;
      },
      _restoreSelection: function(range) {
        var sel;
        if (range) {
          if (window.getSelection) {
            sel = window.getSelection();
            sel.removeAllRanges();
            for (var i = 0, len = range.length; i < len; ++i) {
              sel.addRange(range[i]);
            }
          } else if (document.selection && range.select) {
            range.select();
          }
        }
      },
      insertLink: function(url) {
        //First add the html to the page..
        $("body").append(
          '<div id="_newHTMLLink" style="display:none"><label class="inforLabel" for="_newHTMLLinkURL">URL</label><input style="width:300px" id="_newHTMLLinkURL" class="inforTextbox"/><br/><br/></div>'
        );
        var self = this;
        if(!self.selection){
          self.element.focus();
        }
        self.selection = self._saveSelection();
        //Invoke the dialog on it
        $("#_newHTMLLink").inforMessageDialog({
          title: "Insert Url",
          dialogType: "General",
          width: 400,
          height: "auto",
          modal: true,
          beforeClose: function() {
            //do something and return false to cancel closing
          },
          close: function(event, ui) {},
          buttons: [
            {
              id: "InsertButton",
              text: "Insert",
              click: function() {
                self._restoreSelection(self.selection);
                $("#InsertButton").addClass("active");
                var linkURL = HtmlSanitizer.SanitizeHtml($(this).find("#_newHTMLLinkURL").val());
				
                var text = HtmlSanitizer.SanitizeHtml(window.getSelection().toString());
                if (!text) {
                  text = linkURL;
                  self.element.focus();
                  self.element.select();
                }
                var html =
                  '<a href="' + linkURL + '" target="_blank">' + text + "</a>";
                //window.document.execCommand('insertHTML', false, '<a href="' + linkURL + '" target="_blank">' + text + '</a>');
                pasteHtmlAtCaret(html);
                $(this).inforDialog("close");
                $("#_newHTMLLink").remove();
                self._restoreSelection(self.selection);
              },
              isDefault: true
            },
            {
              text: Globalize.localize("Cancel"),
              click: function() {
                $(this).inforDialog("close");
                $("#_newHTMLLink").remove();
                self._restoreSelection(self.selection);
              }
            }
          ]
        });
        $("#_newHTMLLink").inforForm();
        $(document)
          .find("#_newHTMLLinkURL")
          .val("");
        
      },
      addButtons: function() {
        var self = this,
          html = "",
          editor = $(this.element),
          tb,
          container;
        container = $('<div class="inforRichTextContainer"></div>');
        if (editor.attr("id")) {
          container.attr("id", editor.attr("id") + "Container");
        }
        if (editor.css("position") === "absolute") {
          container.css({
            position: "absolute",
            left: editor.css("left"),
            top: editor.css("top"),
            bottom: editor.css("bottom")
          });
          editor.css({ position: "", left: "", top: "", bottom: "" });
        }
        editor.wrap(container);
        tb = $('<div class="inforToolbar inforRTToolbar" ></div>').insertBefore(
          editor
        );
        editor.on("blur", function() {
          self.selection = self._saveSelection();
          setTimeout(function() {
            var tagName = document.activeElement
              ? document.activeElement.tagName.toUpperCase()
              : "";
            if (
              tagName !== "INPUT" &&
              tagName !== "TEXTAREA" &&
              tagName !== "BUTTON" &&
              tagName !== "DIV" &&
              tagName !== "BODY"
            ) {
              self._restoreSelection(self.selection);
            }
          }, 1);
        });
        //Create buttons
        self.buttons = [];
        $.each(settings.buttons, function(name, props) {
          if (props.icon === "spacer") {
            $('<span class="inforToolbarSpacer"></span>').appendTo(tb);
            return;
          }
          /*
                      if (props.icon === 'formatblock') {
                        html = '<select class="inforDropDownList" style="width: 70px"> <option value="<h2>">Heading 2</option> <option value="<h3>">Heading 3</option> <option value="<p>">Normal</option> </select>';
                        //add color picker
                        self.fontsize = $(html).appendTo(tb);
                        self.fontsize.inforDropDownList({editable: false, noFocus: true, autoFocus: false, typeAheadSearch: false})
                        .on('change', function() {
                          var format = this[this.selectedIndex].value;
                          setTimeout(function () {
                            self._restoreSelection(self.selection);
                            document.execCommand('formatblock', false, format);
                          }, 1);
                        });
                        return;
                      }*/
          if (props.icon === "forecolor") {
            //add color picker
            self.colorpicker = $(
              '<input type="text" class="inforColorPicker" >'
            ).appendTo(tb);
            self.colorpicker.inforColorPicker().change(function() {
              $(self.element).focus();
              document.execCommand("forecolor", false, $(this).val());
              // restore text editor focus after foreground color selection in IE.
              setTimeout(function() {
                $(self.element).focus();
              }, 100);
            });
            var picker = self.colorpicker.closest(".inforTriggerField");
            picker.find("input").hide();
            picker
              .find(".inforColorButton")
              .attr(
                "style",
                "border-right: none !important; margin-left: -1px !important"
              )
              .attr("title", Globalize.localize("SetTextColor"))
              .inforToolTip();
            return;
          }
          var button = $(
            '<button type="button" class="inforIconButton"><span></span></button>'
          )
            .appendTo(tb)
            .click(function(e) {
              if (!$(e.target).hasClass("links")) {
                // HPS-90833 Focus interferes with the links button, so skip
                $(self.element).focus();
              }
              if (props.click) {
                props.click(e, self);
                return;
              }
              var isIE =
                navigator.appName === "Microsoft Internet Explorer" ||
                (navigator.appName === "Netscape" &&
                  new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})").exec(
                    navigator.userAgent
                  ) !== null);
              var el = props.args;
              if (isIE) {
                if (el === "blockquote") {
                  return document.execCommand("indent", false, el);
                }
                el = "<" + el + ">";
              }
              document.execCommand(props.execCommand, false, el);
              $(self.element).focus();
              if (props.isToggle) {
                $(this).toggleClass("checked");
              }
            })
            .addClass(props.icon)
            .addClass(props.isToggle ? "inforToggleButton" : "")
            .attr("title", props.title)
            .inforToolTip();
          if (props.text) {
            button.html(props.text);
          }
          if (props.icon === "showHtml") {
            var id = editor.attr("id") + "HtmlView";
            self.sourceView = $(
              '<textarea class="inforRichTextHtmlView" id="' + id + '">'
            )
              .appendTo(editor.parent())
              .hide();
            button.html("HTML").on("click", function() {
              var btn = $(this);
              var isSourceView = self.sourceView.is(":visible");
              if (isSourceView) {
                self.sourceView.hide();
				
				var htmlCommentsValue = $("#" + id)
                    .val()
                    .trim()
				
                editor.html(HtmlSanitizer.SanitizeHtml(htmlCommentsValue));

                editor.show();
                btn.removeClass("checked");
              } else {
                self.sourceView.css({
                  height: editor.css("height"),
                  width: editor.css("width")
                });
                self.sourceView.show();
                $("#" + id).val(editor.html().trim());
                $("#" + self.element.attr("id") + "HtmlView").bind(
                  "input propertychange",
                  function(e) {
                    $(e.target)
                      .parent()
                      .find(".inforRichTextEditor")
                      .html($(e.target).val());
                  }
                );
                editor.hide();
                btn.addClass("checked");
              }
            });
          }
          self.buttons.push({ id: props.icon, button: button });
        });
      },
      handleKeys: function() {
        var elem = this.element,
          self = this;
        elem
          .on("keyup.richtext", function() {
            self.setButtonStates();
          })
          .on("mouseup.richtext", function() {
            self.setButtonStates();
          });
      },
      setButtonStates: function() {
        this.testButtonState("bold");
        this.testButtonState("italic");
        this.testButtonState("underline");
      },
      testButtonState: function(command) {
        var elem;
        if (!document.queryCommandState) {
          return;
        }
        elem = $.grep(this.buttons, function(e) {
          return e.id === command;
        });
        if (!elem[0].button) {
          return;
        }
        if (document.queryCommandState(command)) {
          elem[0].button.addClass("checked");
        } else {
          elem[0].button.removeClass("checked");
        }
      }
    };
    function pasteHtmlAtCaret(html) {
      var sel, range;
      if (window.getSelection) {
        // IE9 and non-IE
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount && canAppendLink(sel)) {
          range = sel.getRangeAt(0);
          range.deleteContents();
          // Range.createContextualFragment() would be useful here but is
          // only relatively recently standardized and is not supported in
          // some browsers (IE9, for one)
          var el = document.createElement("div");
          el.innerHTML = html;
          var frag = document.createDocumentFragment(),
            node,
            lastNode;
          while ((node = el.firstChild)) {
            lastNode = frag.appendChild(node);
          }
          var firstNode = frag.firstChild;
          range.insertNode(frag);
          if (lastNode) {
            range = range.cloneRange();
            range.setStartAfter(lastNode);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
          }
        }
      } else if ((sel = window.selection) && sel.type != "Control") {
        // IE < 9
        var originalRange = sel.createRange();
        originalRange.collapse(true);
        sel.createRange().pasteHTML(html);
      }
    }
    // Checks if the selection is in bounds with the targeted control and can be appended
    function canAppendLink(sel) {
      var canAppend = false;
      // Use 'parents' instead of the single 'parent' jquery function since it's possible that there are nested elements in the htmlArea
      var parentNode = $(sel.anchorNode).parents(".inforRichTextEditor");
      if (parentNode.context !== null) {
        var isInControlBounds =
          parentNode.length > 0
            ? $(parentNode[0]).hasClass("inforRichTextEditor")
            : $(parentNode.context).hasClass("inforRichTextEditor");
            
        var isTextElement =
          sel.anchorNode.nodeName.toLowerCase().indexOf("text") !== -1 ||
          sel.anchorNode.nodeName.toLowerCase().indexOf("font") !== -1;

        //FinalCheck if TextElement
        if(!isTextElement){
          if(sel.anchorNode.className){
            var isTextElement =
            sel.anchorNode.className.toLowerCase().indexOf("text") !== -1 ||
            sel.anchorNode.className.toLowerCase().indexOf("font") !== -1;
          }
        }
        // Checks if if parent node is within a text editor and if the anchorNode is not a text element.
        if (!isInControlBounds && (!isInControlBounds && !isTextElement))
          canAppend = false;
        else canAppend = true;
      }
      return canAppend;
    }
    // Support Chaining and Init the Control or Set Settings
    return this.each(function() {
      var instance = $.data(this, pluginName);
      if (instance) {
        instance.settings = $.extend({}, defaults, options);
      } else {
        instance = $.data(this, pluginName, new Plugin(this, settings));
      }
    });
  };
})(jQuery);


/// https://github.com/jitbit/HtmlSanitizer
/// Client-side HTML Sanitizer to prevent XSS and unwanted tags. Supported by all major browsers, IE10 and higher.
/// It uses browser/DOM to parse the html by using DOMParser object (hence the browser "front-end only" requirement) which makes it much faster than "pure JavaScript" sanitizers.
/// Tested on https://www.bbc.co.uk homepage - the page is sanitized ~370 times per second on an i5 core CPU in Firefox Quantum (tested via benchmark.js)

'use strict'

const HtmlSanitizer = new (function () {

	const _tagWhitelist = {
		'A': true, 'ABBR': true, 'B': true, 'BLOCKQUOTE': true, 'BODY': true, 'BR': true, 'CENTER': true, 'CODE': true, 'DD': true, 'DIV': true, 'DL': true, 'DT': true, 'EM': true, 'FONT': true,
		'H1': true, 'H2': true, 'H3': true, 'H4': true, 'H5': true, 'H6': true, 'HR': true, 'I': true, 'IMG': true, 'LABEL': true, 'LI': true, 'OL': true, 'P': true, 'PRE': true,
		'SMALL': true, 'SOURCE': true, 'SPAN': true, 'STRONG': true, 'SUB': true, 'SUP': true, 'TABLE': true, 'TBODY': true, 'TR': true, 'TD': true, 'TH': true, 'THEAD': true, 'UL': true, 'U': true, 'VIDEO': true
	};

	// Tags that will be converted to DIVs
	const _contentTagWhiteList = { 'FORM': true, 'GOOGLE-SHEETS-HTML-ORIGIN': true };
	// Whitelist of allowed attributes
	const _attributeWhitelist = { 'align': true, 'color': true, 'controls': true, 'height': true, 'href': true, 'id': true, 'src': true, 'style': true, 'target': true, 'title': true, 'type': true, 'width': true };
	// Whitelist of allowed CSS styles
	const _cssWhitelist = { 'background-color': true, 'color': true, 'font-size': true, 'font-weight': true, 'text-align': true, 'text-decoration': true, 'width': true };
	// Whitelist of allowed URI schemes
	const _schemaWhiteList = [ 'http:', 'https:', 'data:', 'm-files:', 'file:', 'ftp:', 'mailto:', 'pw:', 'TRIM:', 'ozone:', 'el:' ]; //which "protocols" are allowed in "href", "src" etc
	// Attributes that might contain URIs
	const _uriAttributes = { 'href': true, 'action': true };
	// DOM parser for parsing HTML strings
	const _parser = new DOMParser();

	this.SanitizeHtml = function (input, extraSelector) {
		input = input.trim();
		if (input == "") return ""; //to save performance

		// Special case handling for single <br> tag
		if (input == "<br>") return ""; 

		// Ensure input has a body tag to avoid skipping certain tags
		if (input.indexOf("<body")==-1) input = "<body>" + input + "</body>";

		let doc = _parser.parseFromString(input, "text/html");

		//DOM clobbering check 
		if (doc.body.tagName !== 'BODY')
			doc.body.remove();
		if (typeof doc.createElement !== 'function')
			doc.createElement.remove();

		function makeSanitizedCopy(node) {
			let newNode;
			if (node.nodeType == Node.TEXT_NODE) { // If the node is a text node
				newNode = node.cloneNode(true);
			} else if (node.nodeType == Node.ELEMENT_NODE && (_tagWhitelist[node.tagName] || _contentTagWhiteList[node.tagName] || (extraSelector && node.matches(extraSelector)))) { //is tag allowed?

				if (_contentTagWhiteList[node.tagName])
					newNode = doc.createElement('DIV'); // Convert to DIV
				else
					newNode = doc.createElement(node.tagName);

				for (let i = 0; i < node.attributes.length; i++) {
					let attr = node.attributes[i];
					if (_attributeWhitelist[attr.name]) {
						if (attr.name == "style") { // Special handling for style attribute
							for (let s = 0; s < node.style.length; s++) {
								let styleName = node.style[s];
								if (_cssWhitelist[styleName])
									newNode.style.setProperty(styleName, node.style.getPropertyValue(styleName));
							}
						}
						else {
							// Handle URI attributes separately
							if (_uriAttributes[attr.name]) { 
								if (attr.value.indexOf(":") > -1 && !startsWithAny(attr.value, _schemaWhiteList))
									continue;
							}
							newNode.setAttribute(attr.name, attr.value);
						}
					}
				}
				// Recursively sanitize child nodes
				for (let i = 0; i < node.childNodes.length; i++) {
					let subCopy = makeSanitizedCopy(node.childNodes[i]);
					newNode.appendChild(subCopy, false);
				}

				// Remove empty inline tags
				if ((newNode.tagName == "SPAN" || newNode.tagName == "B" || newNode.tagName == "I" || newNode.tagName == "U")
					&& newNode.innerHTML.trim() == "") {
					return doc.createDocumentFragment();
				}
				
			} else {
				// If the tag is not allowed, create a document fragment (empty node)
				newNode = doc.createDocumentFragment();
			}
			return newNode;
		};

		let resultElement = makeSanitizedCopy(doc.body);
		
		// Format the result HTML
		return resultElement.innerHTML
			.replace(/<br[^>]*>(\S)/g, "<br>$1")
			.replace(/div><div/g, "div><div"); 
	}

	// Helper function to check if a string starts with any of the given substrings
	function startsWithAny(str, substrings) {
		for (let i = 0; i < substrings.length; i++) {
			if (str.indexOf(substrings[i]) == 0) {
				return true;
			}
		}
		return false;
	}

	this.AllowedTags = _tagWhitelist;
	this.AllowedAttributes = _attributeWhitelist;
	this.AllowedCssStyles = _cssWhitelist;
	this.AllowedSchemas = _schemaWhiteList;
});